__turbopack_context__.v({
  "company-badge": "index-module-scss-module__xiruNW__company-badge",
  "private-user-column": "index-module-scss-module__xiruNW__private-user-column",
  "private-user-contact": "index-module-scss-module__xiruNW__private-user-contact",
  "private-user-container": "index-module-scss-module__xiruNW__private-user-container",
  "private-user-info": "index-module-scss-module__xiruNW__private-user-info",
  "shop-details-wrapper": "index-module-scss-module__xiruNW__shop-details-wrapper",
  "shop-link": "index-module-scss-module__xiruNW__shop-link",
  "shop-with-contact": "index-module-scss-module__xiruNW__shop-with-contact",
  "user-details-name": "index-module-scss-module__xiruNW__user-details-name",
  "user-name": "index-module-scss-module__xiruNW__user-name",
});
